import { useEffect, useState } from "react";
import { httpGet } from "../utils/fetch-client";
import { loginPath, userInfoPath } from "../utils/urls";
import { Table } from "designsystem/src/stories/Elements/Table";
import { ReactSVG } from "react-svg";
import { IconButton } from "designsystem/src/stories/Controls/IconButton";
import { t } from "i18next";
import { I18NButton } from "designsystem/src/stories/Controls/I18NButton";
import { I18NParagraph } from "designsystem/src/stories/Elements/I18NParagraph";
import { I18NHeading } from "designsystem/src/stories/Elements/I18NHeading";

import fidodemoSuccess from "../assets/images/fidodemo-success-1.svg";

interface UserInfo {
	returnUrl?: string | null,
	fullName?: string | null,
	claims?: object | null
}

export function SuccessPage() {

	const [returnUrl, setReturnUrl] = useState<string>("");
	const [fullName, setFullName] = useState<string>("");
	const [claims, setClaims] = useState<string[][]>([]);
	const [tableVisible, setTableVisible] = useState<boolean>(false);

	async function fetchUserInfo() {
		const { status, payload } = await httpGet<UserInfo>(userInfoPath);

		if (status === 401) {
			window.location.assign(loginPath);
		}

		if (status === 200 && payload) {
			setReturnUrl(payload.returnUrl ?? "");
			setFullName(payload.fullName ?? "");
			// the values of the claims object are typically strings but can also be arrays, so we convert them to strings
			setClaims(Object.entries(payload.claims ?? {}).map(([k, v]) => [k, String(v)]));
		}
	}

	useEffect(() => {
		fetchUserInfo();
	}, []);

	return <>
		<div className="header-svg">
			<div className="center-svg">
				<ReactSVG className="Merck-Regular" src={fidodemoSuccess.toString()} />
			</div>
		</div>

		<I18NHeading i18n={"fidodemo.success-greeting"} options={{ fullName: fullName }} type={"h3"} />
		<I18NParagraph id="fidodemo-succes-message" i18n={"fidodemo.success-message"} />

		{returnUrl &&
			<a href={returnUrl} className="back-button">
				<I18NButton i18n="fidodemo.back-button" mode="yellow" />
			</a>
		}

		<div className="details-table-collapsible">
			<IconButton buttonId="fido-details-table-collapsible" icon={"arrow"} label={t("fidodemo.success-details")}
									onClick={() => setTableVisible(!tableVisible)} />
			{tableVisible &&
				<>
					<hr className="hr-dark" />
					<Table rows={claims} numberOfCols={2} firstRowAsHeader={false} className="details-table" />
				</>
			}
		</div>
	</>;
}
